/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL21haW4vZmluYW5jaWFsL2ZpbmFuY2lhbC1kYXNoYm9hcmQvZmluYW5jaWFsLWRhc2hib2FyZC5jb21wb25lbnQuc2NzcyJ9 */"];
export { styles as styles };
